// import React from "react";
// import { FaPhoneAlt } from "react-icons/fa";
// import { FaWhatsapp } from "react-icons/fa";
// import { MdOutlineEmail } from "react-icons/md";
// import { IoLocation } from "react-icons/io5";
// import img1 from "../../assets/s01.jpeg";
// import BtnRounded from "./BtnRounded";
// import OpenCalendly from "./OpenCalendly";
// const ServiceItem = () => {
//   return (
//     <div className="min-h-screen mt-[90px]">
//       {/* Header Section */}
//       <div className="bg-customAqua100/20  text-cuqtomAqua600 text-center py-12 ">
//         <h1 className="text-3xl font-thin">Soins conservateurs</h1>
//       </div>

//       {/* Content Section */}
//       <div className="grid md:grid-cols-2 gap-6 mt-12 items-center lg:px-20">
//         {/* Contact Information */}
//         <div className="  p-6 ">
//           <div className="mb-10">
//             <p className="text-gray-500">
//               Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iusto
//               nisi saepe sunt ullam, quibusdam doloremque laboriosam dignissimos
//               sapiente pariatur quia ut magni repellendus sit voluptate suscipit
//               delectus assumenda eius sequi. Lorem ipsum dolor, sit amet
//               consectetur adipisicing elit. Iusto nisi saepe sunt ullam,
//               quibusdam doloremque laboriosam dignissimos sapiente pariatur quia
//               ut magni repellendus sit voluptate suscipit delectus assumenda
//               eius sequi. Lorem ipsum dolor, sit amet consectetur adipisicing
//               elit. Iusto nisi saepe sunt ullam, quibusdam doloremque laboriosam
//               dignissimos sapiente pariatur quia ut magni repellendus sit
//               voluptate suscipit delectus assumenda eius sequi.
//             </p>
//           </div>

//           <div className="space-y-4 text-gray-500 bg-customAqua100/5 p-6">
//             {/* Phone Information */}
//             <h2 className="text-xl font-extralight text-customBlue">
//               Contactez le centre dentaire
//             </h2>
//             <div className="border border-solid border-customAqua600 w-1/12 "></div>
//             <div className="flex items-center space-x-3">
//               <FaPhoneAlt className="text-customAqua100" />
//               <div>
//                 <p>+212 537 666 666</p>
//                 <p>+212 537 349 346</p>
//               </div>
//             </div>
//             {/* WhatsApp Information */}
//             <div className="flex items-center space-x-3">
//               <FaWhatsapp className="text-customAqua100" />
//               <p>+212 648 130 021</p>
//             </div>
//             {/* Email Information */}
//             <div className="flex items-center space-x-3">
//               <MdOutlineEmail className="text-customAqua100" />
//               <p>contact@drcherkaouiabir.ma</p>
//             </div>
//             {/* Address Information */}
//             <div className="flex items-center space-x-3">
//               <IoLocation className="text-customAqua100" />
//               <p>48, Rue Ghandi, Rabat</p>
//             </div>
//           </div>
//         </div>

//         {/* Image Section */}
//         <div className="rounded-md overflow-hidden shadow-md">
//           <img
//             src={img1}
//             alt="Service Image"
//             className="w-full h-auto object-cover"
//           />
//         </div>
//       </div>

//       {/* Call to Action Section */}
//       <div className="flex flex-row items-center justify-around mt-12 text-center bg-customAqua100/20 py-20">
//         <div className="">
//           <h3 className="text-2xl font-thin text-customAqua600">
//             Prêt à prendre rendez-vous ?
//           </h3>
//           <p className="text-customAqua600 font-light mt-4">
//             Contactez-nous dès maintenant pour prendre rendez-vous et bénéficier
//             des meilleurs soins.
//           </p>
//         </div>
//         <BtnRounded>
//           <OpenCalendly />
//         </BtnRounded>
//       </div>
//     </div>
//   );
// };

// export default ServiceItem;

import React from "react";
import { useParams } from "react-router-dom"; // Import useParams for router params
import { FaPhoneAlt } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { IoLocation } from "react-icons/io5";
import { list_services_page } from "../../data/services"; // Import your services array
import BtnRounded from "./BtnRounded";
import OpenCalendly from "./OpenCalendly";
import Booking from "./Booking";

const ServiceItem = () => {
  const { id } = useParams(); // Get the id from the URL
  const data = list_services_page.find((item) => item.id == id); // Find the object

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h1 className="text-2xl text-red-500">Service not found!</h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen mt-[90px]">
      {/* Header Section */}
      <div className="bg-customAqua100/20 text-customAqua600 text-center py-12 ">
        <h1 className="text-3xl font-thin">{data.title}</h1>
      </div>

      {/* Content Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2  gap-6 mt-12 items-center lg:px-20">
        {/* Service Information */}
        <div className="p-6">
          <div className="mb-10">
            <p className="text-gray-500">{data.description}</p>
          </div>
          <div className="space-y-4 text-gray-500 bg-customAqua100/5 p-6">
            <h2 className="text-xl font-extralight text-customBlue">
              Étapes de la procédure
            </h2>
            <div className="border border-solid border-customAqua600 w-1/12 mb-4"></div>
            <ul className="list-disc pl-5">
              {data.steps.map((step, index) => (
                <li key={index} className="mb-2">
                  {step}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Image Section */}
        <div className="rounded-md overflow-hidden shadow-md mx-8 lg:mx-2 md:mx-4">
          <img
            src={data.imagePath}
            alt={`Image of ${data.title}`}
            className="w-full h-auto object-cover"
          />
        </div>
      </div>

      <Booking />
    </div>
  );
};

export default ServiceItem;
